<template>
  <div class="text-center mobile-day py-2 w-full box-border flex mr-2 border-t">
    <div class="w-[69px] py-4">
      <h2 class="regular text-xs my-0">
        {{ isDaily ? column.label : column.dayOfWeekMobile }}
      </h2>
      <span v-if="!isDaily" class="text-xl">
        {{ column.labelMobile }}
      </span>
    </div>
    <ul class="list-none pl-0 mobile-list flex-auto my-0 w-full">
      <PlannerItemMobile v-for="item in column.items" :key="item.id" :session="item" />
    </ul>
  </div>
</template>

<script setup>

import { defineProps } from 'vue';

import PlannerItemMobile from './PlannerItemMobile.ce.vue';

defineProps({
  column: {
    type: Object,
    default: () => ({})
  },
  isDaily: {
    type: Boolean,
    default: false
  },
  isGroupAndPastDay: {
    type: Boolean,
    default: false
  }
});

</script>
